import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tabs: []
  },
  mutations: {
    add(state, tab) {
      let isExist = state.tabs.filter(i => i.title == tab.title);
      if (isExist.length == 0) {
        state.tabs.push(tab);
      }
    },
    remove(state, tab) {
      let start = -1;
      state.tabs.forEach((i, index) => {
        if (i.title == tab.title) start = index;
      });
      if (start != -1) {
        state.tabs.splice(start, 1);
      }
    }
  },
  actions: {
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js